export { default as IdentificationIcon } from './IdentificationIcon';
